import request from "../utils/request";

export default {
	__getList() {
		return request({
			url: `portfolio/list`,
			method: "GET"
		});
	},
	__getData(id) {
		return request({
			url: `portfolio/${id}`,
			method: "GET"
		});
	},
	__createData(data) {
		return request({
			url: `portfolio/new`,
			method: "POST",
			data
		});
	},
	__updateData({ id, data }) {
		return request({
			url: `portfolio/${id}`,
			method: "PUT",
			data
		});
	},
	__removeData(id) {
		return request({
			url: `portfolio/${id}`,
			method: "DELETE"
		});
	},
}